import { ComponentType } from "react";
import { SvgIconComponent } from "@mui/icons-material";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import RocketLaunchOutlinedIcon from "@mui/icons-material/RocketLaunchOutlined";
import ConfirmationNumberOutlinedIcon from "@mui/icons-material/ConfirmationNumberOutlined";
import MonitorHeartOutlinedIcon from "@mui/icons-material/MonitorHeartOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import CardGiftcardOutlinedIcon from "@mui/icons-material/CardGiftcardOutlined";
import TabletAndroidOutlinedIcon from "@mui/icons-material/TabletAndroidOutlined";
import DesignServicesOutlinedIcon from "@mui/icons-material/DesignServicesOutlined";
import SystemUpdateAltOutlinedIcon from "@mui/icons-material/SystemUpdateAltOutlined";
import PaletteOutlinedIcon from "@mui/icons-material/PaletteOutlined";
import CollectionsOutlinedIcon from "@mui/icons-material/CollectionsOutlined";
import ViewCarouselOutlinedIcon from "@mui/icons-material/ViewCarouselOutlined";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import TravelExploreOutlinedIcon from "@mui/icons-material/TravelExploreOutlined";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";
import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";
import QrCode2OutlinedIcon from "@mui/icons-material/QrCode2Outlined";
import BrushOutlinedIcon from "@mui/icons-material/BrushOutlined";
import ContactMailOutlinedIcon from "@mui/icons-material/ContactMailOutlined";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import CelebrationOutlinedIcon from "@mui/icons-material/CelebrationOutlined";

import Dashboard from "./views/Dashboard";
import Devices from "./views/Device/components/Devices";
import Versions from "./views/Versions";
import Klydos from "./views/Klydos/components/Klydos";
import Users from "./views/Klydos/Users/components/Users";

import DevicesMap from "./views/DevicesMap/DevicesMap";

import Gifts from "./views/Gifts/components/Gifts";
import Collections from "./views/Collection/components/Collections";
import ReviewsSection from "./views/Reviews/components/Reviews";
import AppHomeEntries from "./views/Entries/components/AppHomeEntries";
import HolidayCalendar from "./views/CalendarEvent/components/CalendarEvents";
import Orders from "./views/Orders/components/Orders";
import Retailers from "./views/Retailers/components/Retailers";
import KlydoMonitorView from "views/KlydoMonitor/KlydoMonitor";
import ExploreCategories from "./views/ExploreCategories/components/ExploreCategories";
import MomentOccasions from "./views/KlydoApp/Moments/components/MomentOccasions";
import VersionTester from "./views/VersionTester/components/VersionTester";
import TicketsPage from "views/Tickets/components/TicketsPage";
import FeatureRequestsPage from "views/FeatureRequests/components/FeatureRequestsPage";
import StudioPage from "views/Studio/components/StudioPage";
import StoryManagement from "./views/StoryManagement/components/StoryManagement";
import Serials from "./views/Serials/components/Serials";
import ArtistsBriefs from "./views/ArtistsBriefs/components/ArtistsBriefs";
import NewArtists from "./views/NewArtists/components/NewArtists";
import ClockCrashes from "./views/ClockCrashes/components/ClockCrashes";
import ClockFieldWatchers from "./views/ClockFieldWatchers/components/ClockFieldWatchers";
import FeatureBetaGroups from "./views/FeatureBetaGroups/components/FeatureBetaGroups";
import ClockConfiguration from "./views/ClockConfiguration/components/ClockConfiguration";
import ContentProfiles from "./views/ContentProfiles/components/ContentProfiles";
import ContentProfileDetail from "./views/ContentProfiles/components/ContentProfileDetail";
import CreativeStudio from "./views/CreativeStudio/components/CreativeStudio";

export type NavSectionName =
  | "Overview"
  | "Devices"
  | "Content"
  | "Commerce"
  | "Klydo App"
  | "People";

export type AppRoute = {
  path: string;
  name: string;
  icon: SvgIconComponent;
  element: ComponentType;
  layout: string;
  /** sidebar / command-palette group — required so new routes can't silently vanish from navigation */
  section: NavSectionName;
  /**
   * Routed, but not in the sidebar/command-palette — for a detail page whose
   * path takes a param (e.g. "/profiles/:id"), which has no single sensible
   * nav target of its own. `name`/`icon`/`section` are still required (used
   * by findRouteByPath/findSectionForRoute for breadcrumb-style lookups) but
   * never rendered as a nav row. Optional and defaults to false, so every
   * existing route's nav behavior is unchanged.
   */
  hideFromNav?: boolean;
};

const dashboardRoutes: AppRoute[] = [
  {
    path: "/dashboard",
    section: "Overview",
    name: "Dashboard",
    icon: SpaceDashboardOutlinedIcon,
    element: Dashboard,
    layout: "/admin",
  },
  {
    path: "/tickets",
    section: "Devices",
    name: "Klydoscope",
    icon: ConfirmationNumberOutlinedIcon,
    element: TicketsPage,
    layout: "/admin",
  },
  {
    path: "/klydo-monitors",
    section: "Devices",
    name: "Klydo Monitors",
    element: KlydoMonitorView,
    icon: MonitorHeartOutlinedIcon,
    layout: "/admin",
  },
  {
    path: "/orders",
    section: "Commerce",
    name: "Orders",
    icon: ShoppingCartOutlinedIcon,
    element: Orders,
    layout: "/admin",
  },
  {
    path: "/retailers",
    section: "Commerce",
    name: "Retailers",
    icon: StorefrontOutlinedIcon,
    element: Retailers,
    layout: "/admin",
  },
  {
    path: "/greets",
    section: "Commerce",
    name: "Greets",
    icon: CardGiftcardOutlinedIcon,
    element: Gifts,
    layout: "/admin",
  },
  {
    path: "/devices",
    section: "Devices",
    name: "Devices",
    icon: TabletAndroidOutlinedIcon,
    element: Devices,
    layout: "/admin",
  },
  {
    path: "/clock-crashes",
    section: "Devices",
    name: "Clock Crashes",
    icon: MonitorHeartOutlinedIcon,
    element: ClockCrashes,
    layout: "/admin",
  },
  {
    path: "/clock-field-watchers",
    section: "Devices",
    name: "Clock Field Watchers",
    icon: NotificationsActiveOutlinedIcon,
    element: ClockFieldWatchers,
    layout: "/admin",
  },
  {
    path: "/feature-beta-groups",
    section: "Devices",
    name: "Feature Beta Groups",
    icon: RocketLaunchOutlinedIcon,
    element: FeatureBetaGroups,
    layout: "/admin",
  },
  {
    path: "/clock-configuration",
    section: "Devices",
    name: "Clock Configuration",
    icon: TuneOutlinedIcon,
    element: ClockConfiguration,
    layout: "/admin",
  },
  {
    path: "/studio",
    section: "People",
    name: "Studio",
    icon: DesignServicesOutlinedIcon,
    element: StudioPage,
    layout: "/admin",
  },
  {
    path: "/versions",
    section: "Devices",
    name: "Versions",
    icon: SystemUpdateAltOutlinedIcon,
    element: Versions,
    layout: "/admin",
  },
  {
    path: "/klydos",
    section: "Content",
    name: "Klydos",
    icon: PaletteOutlinedIcon,
    element: Klydos,
    layout: "/admin",
  },
  {
    path: "/collections",
    section: "Content",
    name: "Collections",
    icon: CollectionsOutlinedIcon,
    element: Collections,
    layout: "/admin",
  },
  {
    path: "/profiles",
    section: "Content",
    name: "Content Profiles",
    icon: LayersOutlinedIcon,
    element: ContentProfiles,
    layout: "/admin",
  },
  {
    path: "/profiles/:id",
    section: "Content",
    name: "Content Profile",
    icon: LayersOutlinedIcon,
    element: ContentProfileDetail,
    layout: "/admin",
    hideFromNav: true,
  },
  {
    path: "/app-home-entries",
    section: "Content",
    name: "Entries",
    icon: ViewCarouselOutlinedIcon,
    element: AppHomeEntries,
    layout: "/admin",
  },
  {
    path: "/reviews",
    section: "Content",
    name: "Reviews",
    icon: RateReviewOutlinedIcon,
    element: ReviewsSection,
    layout: "/admin",
  },
  {
    path: "/users",
    section: "People",
    name: "Users",
    icon: PersonOutlineOutlinedIcon,
    element: Users,
    layout: "/admin",
  },
  {
    path: "/feature-requests",
    section: "People",
    name: "Feature Requests",
    icon: LightbulbOutlinedIcon,
    element: FeatureRequestsPage,
    layout: "/admin",
  },
  {
    path: "/map",
    section: "Overview",
    name: "Real time stats",
    element: DevicesMap,
    icon: MapOutlinedIcon,
    layout: "/admin",
  },
  {
    path: "/calendar-events",
    section: "Content",
    name: "Scheduler",
    icon: CalendarMonthOutlinedIcon,
    element: HolidayCalendar,
    layout: "/admin",
  },
  {
    path: "/klydo-app/moments",
    section: "Klydo App",
    name: "Moments",
    icon: CelebrationOutlinedIcon,
    element: MomentOccasions,
    layout: "/admin",
  },
  {
    path: "/explore-categories",
    section: "Content",
    name: "Explore",
    icon: TravelExploreOutlinedIcon,
    element: ExploreCategories,
    layout: "/admin",
  },
  {
    path: "/artists-briefs",
    section: "Content",
    name: "Artists Briefs",
    icon: BrushOutlinedIcon,
    element: ArtistsBriefs,
    layout: "/admin",
  },
  {
    path: "/new-artists",
    section: "Content",
    name: "New Artists",
    icon: ContactMailOutlinedIcon,
    element: NewArtists,
    layout: "/admin",
  },
  {
    path: "/version-tester",
    section: "Devices",
    name: "Version Tester",
    icon: ScienceOutlinedIcon,
    element: VersionTester,
    layout: "/admin",
  },
  {
    path: "/creative-studio",
    section: "Content",
    name: "Creative Studio",
    icon: AutoAwesomeOutlinedIcon,
    element: CreativeStudio,
    layout: "/admin",
  },
  {
    path: "/story-management",
    section: "Content",
    name: "Story Management",
    icon: AutoStoriesOutlinedIcon,
    element: StoryManagement,
    layout: "/admin",
  },
  {
    path: "/serials",
    section: "Devices",
    name: "Serials",
    icon: QrCode2OutlinedIcon,
    element: Serials,
    layout: "/admin",
  },
];

export default dashboardRoutes;
